module.exports = __webpack_public_path__ + "img/Og-graph-p-500.ec9324b6.png";